import React, { useEffect } from "react";
import { Prompt } from "react-router";
import { FaExclamationTriangle } from "react-icons/fa";
import styled from "styled-components";
import Button from "../Button";
import Text from "../Text";

const message =
  "You have unsaved changes. Are you sure you want to leave this page?";

const NoticeBar = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;
  display: flex;
  align-items: center;
  background-color: white;
  border: 1px solid ${(props) => props.theme.colors.grey3};
  border-left: 4px solid ${(props) => props.theme.colors.warning};
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px 0px;
  padding: 12px 18px;
  max-width: calc(100vw - 24px);

  & > svg {
    color: ${(props) => props.theme.colors.warning};
    margin-right: 12px;
    flex-shrink: 0;
  }
`;

export type UnsavedChangesNoticeProps = {
  when: boolean;
  onSave?: () => void;
};

export function UnsavedChangesNotice({
  when,
  onSave,
}: UnsavedChangesNoticeProps) {
  useEffect(() => {
    if (!when) return () => {};

    const beforeUnloadCallback = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", beforeUnloadCallback);
    return () => {
      window.removeEventListener("beforeunload", beforeUnloadCallback);
    };
  }, [when]);

  return (
    <>
      <Prompt when={when} message={message} />
      {when && (
        <NoticeBar>
          <FaExclamationTriangle />
          <Text fontWeight={600} mr={3}>
            This form has unsaved changes
          </Text>
          {onSave && (
            <Button color="primary" type="button" onClick={onSave}>
              Save Form
            </Button>
          )}
        </NoticeBar>
      )}
    </>
  );
}
